(() => {
    class Cart {
        constructor() {
            /* Config */
            this.revision = 1;
            /* Update Cart */
            this.update();
            // Observers
            App.Observer.register(this);
            App.Interface.User.Observer.register(this);
        }

        get Observer() {
            if (!this._observer)
                this._observer = new App.Entities.Observer(this);
            return this._observer;
        }

        addMix(id, amount = 1, success = null) {
            App.Page.post(App.Route('shop.cart.put'), {
                amount:             amount,
                offer_identifier:   'custom-' + id,
            });
            if (success) success();
        }

        addOffer(id, amount, success) {
            id = parseInt(id);
            /* Find out if cart has already items with this id */
            App.Endpoint.Cart.get = cart => {
                /* Sum offers from cart */
                cart.items.forEach(item => {
                    if (id === item.id) amount += item.amount;
                });
                /* Add Offer to cart */
                Shop.Cart.updateOffer(id, amount, () => {
                    /* Show notification */
                    App.Interface.Api.findById( // Get offers Information
                        'offers',
                        id,
                        /* Success */
                        offer => {
                            this.trackOffer(offer, amount);
                            /**
                             * @todo: remove after cart works with the Cart observer
                             * Reload page in the cart, because it does not refresh while notifying and we need to show
                             * instant changes
                             */
                            if (!['/shop/checkout', '/shop/checkout/'].includes(window.location.pathname)) {
                                if (window.location.pathname === '/shop/cart' || window.location.pathname === '/shop/cart/') {
                                    location.reload();
                                } else {
                                    App.execute('Offer-Notification-Success', {id: id, offer: offer, amount: amount});
                                }
                            }
                        }
                    );
                    success();
                });
            };
        }

        trackOffer(offer, quantity = 1, action = 'add') {
            let products = {
                'actionField': {list: 'Shopping cart'},
                'products': [{
                    'item_name':     offer.name,
                    'item_id':       offer.id ? offer.id.toString() : '', // for GA this needs to be a string
                    'price':         App.Interface.Currency.toNumber(offer.price),
                    'item_brand':    App.Variable('brand') || '',
                    'item_category': App.Variable('category') || '',
                    'item_category2': window.location.pathname,
                    'item_variant':  '',
                    'quantity':      quantity,
                }],
            };
            let values = {'currencyCode': 'EUR'};
            values[action] = products;
            dataLayer.push({
                event:      'eec.add',
                ecommerce:  values,
            });
            return this;
        }

        /*
        * Encash Voucher to Cart
        */
        encashVoucher(code, callback = function() {}) {
            $.ajax({
                url: App.Route('shop.encashvoucher'),
                method: 'POST',
                data: {"voucher_code": code},
                async: false,
                dataType: 'json'
            }).done(function (data) {
                callback(data);
            }).fail(function () {
                callback(null);
            });
        }

        /*
        * Remove Voucher from Cart
        */
        removeVoucher(offer, callback = function() {}) {
            $.ajax({
                url: App.Route('shop.cart.removevoucher'),
                method: 'POST',
                data: {amount: 1, product_id: 0, offer_id: offer},
                async: false,
                dataType: 'json'
            }).done(function (data) {
                callback(data);
            }).fail(function () {
                console.log('ERROR: Not possible to remove voucher');
            });
        }

        /*
        * Update Offer to Cart
        */
        updateOffer(id, amount, callback = function() {}) {
            let Self = this;
            App.Interface.Api.post('carts', [], [{
                'id':               id,
                'amount':           amount,
                'revision':         this.revision,
                'type':            'product',
                'offerButtonType': 'offerbutton'
            }], {
                contentType: 'application/json',
            }, function () {
                callback();
                Self.update();
            });
        }

        /* Update Interface */
        async update() {
            App.Endpoint.Cart.get = cart => this.Observer.notify();
        }
    }
    Shop.Cart = new Cart();
})();
